import { FunctionComponent, useCallback } from 'react'
import Router from 'next/router'
import styled from 'styled-components'
import PageLayout from 'components/PageLayout'
import { Container, Button } from '../../components'
import { useOpenCustomerMessageForm } from '../../components/customer-message-form'

const ErrorContent = styled.div`
  background: rgb(0, 0, 0, 0, 03);
  padding-top: 80px;
  padding-bottom: 200px;
  margin: 0 auto;
  text-align: center;
`

const ErrorTitle = styled.p`
  font-size: 40px;
  color: #f52020;
`

const ErrorText = styled.p`
  padding-top: 32px;
  color: rgb(0, 0, 0, 0.6);
`

const ButtonContainer = styled.div`
  padding-top: 104px;
  width: 328px;
  margin: 0 auto;
  text-align: center;

  button {
    height: 48px !important;
    width: 328px !important;
    font-weight: 500;
  }
`

const QnAButton = styled((props) => <Button {...props} />)`
  margin-top: 8px;
  border: 1px solid #00a0ff;
  color: #01a0ff;
`

interface ErrorScreenProps {
  title: string
  subTitle: string
}

const ErrorScreen: FunctionComponent<ErrorScreenProps> = (props) => {
  const { title, subTitle } = props
  const openCustomerMessageForm = useOpenCustomerMessageForm()

  const handlePrevButton = useCallback(() => {
    Router.back()
  }, [])

  return (
    <PageLayout>
      <Container>
        <ErrorContent>
          <ErrorTitle>{title}</ErrorTitle>
          <ErrorText>
            Ooops!
            <br />
            {subTitle}
          </ErrorText>
          <ButtonContainer>
            <Button
              className="is-primary is-fullwidth"
              onClick={handlePrevButton}
            >
              이전으로
            </Button>
            <QnAButton
              className="is-fullwidth"
              onClick={openCustomerMessageForm}
            >
              고객문의하기
            </QnAButton>
          </ButtonContainer>
        </ErrorContent>
      </Container>
    </PageLayout>
  )
}

export default ErrorScreen
